<ng-container *ngIf="!successMessage;else sentMessageResult;">
	<form [formGroup]="tenantForm" (ngSubmit)="onSubmit()">
		<mat-card class="mat-elevation-z">
			<div class="flex flex-row justify-between items-center">
				<mat-card-content class="fs-24 fw-700">{{'TENANT_FORM.NAME' | transloco}}</mat-card-content>
				<mat-icon class="justify-items-end cursor-pointer icon-lg mr-16" (click)="closeSidenav()"  svgIcon="close"></mat-icon>
			</div>
			<mat-divider></mat-divider>
			<mat-card-content>
				<div class="flex flex-col form-group mat-subheading-2 mt-16">
					<label class="fw-700 fs-12" for="username">{{'TENANT_FORM.TENANT_NAME' | transloco | uppercase}}</label>
					<input type="text" placeholder="{{'TENANT_FORM.TENANT_NAME' | transloco}}"
						formControlName="tenantId" class="fw-500" required >
						<app-error [control]="tenantForm.get('tenantId')"></app-error>
				</div>
			</mat-card-content>
			<mat-card-content>
				<div class="flex flex-col form-group mat-subheading-2">
					<div class="flex flex-row">
						<label class="fw-700 fs-12">{{'TENANT_FORM.TEMENOS_CLOUD' | transloco | uppercase}}</label>
						<mat-icon svgIcon="info" class="icon-sm ml-4 mt-4" matTooltipClass="form-tooltip right" [matTooltip]="'TENANT_FORM.SELECT_CLOUD' | transloco"
						matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
					</div>
					<mat-select [formControl]="tenantForm.get('cloudProvider')" class="fw-500 form-select" [placeholder]="'TENANT_FORM.CHOOSE_CLOUD' | transloco" required>
						<mat-option *ngFor="let cloud of cloud" [value]="cloud">{{ cloud | titlecase }}</mat-option>
					</mat-select>
					<app-error [control]="tenantForm.get('cloudProvider')"></app-error>
				</div>
			</mat-card-content>
			<mat-card-content>
				<div class="flex flex-col form-group mat-subheading-2">
					<div class="flex flex-row">
						<label class="fw-700 fs-12">{{'TENANT_FORM.TEMENOS_REGION' | transloco | uppercase}}</label>
						<mat-icon svgIcon="info" class="icon-sm ml-4 mt-4" matTooltipClass="form-tooltip right" [matTooltip]="'TENANT_FORM.SELECT_REGION' | transloco"
						matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
					</div>
					<mat-select [formControl]="tenantForm.get('regionPair')" class="fw-500 form-select" [placeholder]="'TENANT_FORM.CHOOSE_REGION' | transloco" required>
						<mat-option *ngFor="let region of regions" [value]="region">{{ region | titlecase }}</mat-option>
					</mat-select>
					<app-error [control]="tenantForm.get('regionPair')"></app-error>
				</div>
			</mat-card-content>
            <mat-card-content>
				<div class="flex flex-col form-group mat-subheading-2">
					<div class="flex flex-row">
						<label class="fw-700 fs-12">{{'TENANT_FORM.TEMENOS_MGMT_TYPE' | transloco | uppercase}}</label>
						<mat-icon svgIcon="info" class="icon-sm ml-4 mt-4" matTooltipClass="form-tooltip right" [matTooltip]="'TENANT_FORM.SELECT_MGMT_TYPE' | transloco"
						matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
					</div>
					<mat-select [formControl]="tenantForm.get('managementType')" class="fw-500 form-select" [placeholder]="'TENANT_FORM.CHOOSE_TYPE' | transloco" required>
						<mat-option *ngFor="let type of managementType" [value]="type">{{ type | titlecase }}</mat-option>
					</mat-select>
					<app-error [control]="tenantForm.get('managementType')"></app-error>
				</div>
			</mat-card-content>
            <mat-card-content>
				<div class="flex flex-col form-group mat-subheading-2">
					<label class="fw-700 fs-12" for="username">{{'TENANT_FORM.CLIENT_NAME' | transloco | uppercase}}</label>
					<input type="text" placeholder="{{'TENANT_FORM.CLIENT_NAME' | transloco}}"
						formControlName="clientName" class="fw-500" required >
						<app-error [control]="tenantForm.get('clientName')"></app-error>
				</div>
			</mat-card-content>
		</mat-card>
		<span class="flex-auto"></span>
		<mat-divider class="mb-32"></mat-divider>
		<div class="flex flex-row justify-end w-100-percent">
			<button [disabled]="loading" type="cancel" class="white" (click)="closeSidenav()">{{'DIALOG.CANCEL' | transloco}}</button>
			<button [disabled]="loading" type="submit" class="accent ml-12" >{{'TENANT_FORM.SUBMIT' | transloco}}</button>
		</div>
	</form>
</ng-container>
<ng-template #sentMessageResult>
	<div class="flex flex-row justify-between">
		<mat-card-content class="fs-24 fw-700">{{'TENANT_FORM.NAME' | transloco}}</mat-card-content>
		<mat-icon class="justify-items-end cursor-pointer icon-lg" (click)="closeSidenav()"  svgIcon="close"></mat-icon>
	</div>
	<mat-divider></mat-divider>
	<span @successMessage class="overflow-y-auto">
		<div class="flex flex-col justify-center items-center message-class-success mb-20 ml-20">
		  <div class="green-oval mt-150 mb-20">
			<mat-icon svgIcon="done"></mat-icon>
		  </div>
		  <div class="mat-headline mb-20">{{'TENANT_FORM.TENANT_ADDED' | transloco}}</div>
		  <div class="flex-row" dir="rtl">
			<button type="button" class="white"
			  (click)="sidenavService.closeRightSidenav()">{{'BUTTONS.CLOSE' | transloco}}</button>
		  </div>
		</div>
	  </span>
</ng-template>
<div class="overlay" *ngIf="isLoading">
	<mat-spinner diameter="24" color="primary" mode="indeterminate"></mat-spinner>
</div>